export default __webpack_public_path__ + "static/media/LastPage2.d67ef6ce.txt";